import { AsyncProviderConfig, useFlags } from "launchdarkly-react-client-sdk";
import type { KeysToCamelCase } from "../types";

export const SPECIAL_REFERRALS_NOT_ACTIVE_FLAG_VALUE = "not-active";

export const LaunchDarklyFlags = {
  "loyalty-analytics": false,
  "migration-emails-enabled": false,
  "notification-email-refactor": false,
  "prepaid-sequential": false,
  "special-referrals": SPECIAL_REFERRALS_NOT_ACTIVE_FLAG_VALUE,
  "subscription-management-section-v-2": false,
  "tiered-loyalty": false,
  "shop-webhooks-processing-with-temporal": false,
  "customer-webhooks-processing-with-temporal": false,
  "customer-payment-method-webhooks-processing-with-temporal": false,
  "product-webhooks-processing-with-temporal": false,
  "unbundle-recover": false,
  "upcoming-order-table-rework": false,
  "customer-portal-extension": false,
  "updated-setup-steps": false,
  "show-shipping-settings": false,
  "bundle-extension": false,
  "active-subscriber-rewards-multiplier": false,
  "prepaid-swapping": false,
  "purchasable-query-improvement": false,
  "refund-webhooks-processing-with-temporal": false,
  "subscription-billing-attempt-failure-webhooks-processing-with-temporal": false,
  "orders-tab": false,
  "order-delete-webhooks-processing-with-temporal": false,
  "order-create-webhooks-processing-with-temporal": false,
  "order-update-webhooks-processing-with-temporal": false,
  "retention-reasons-for-skip-and-set-next-order-date": false,
  "subscription-billing-attempt-success-webhooks-processing-with-temporal": false,
  "posthog-session-replay": false,
  "enabled-klaviyo-o-auth": false,
  "customer-portal-payment-methods": false,
  "customer-portal-app-proxy": false,
  "customer-orders-history-embedded": false,
  "out-of-stock-item-removal": false,
  "instant-digital-item-order": false,
  "payment-method-recovery": false,
  "bulk-updates-feature-flag": false,
  "bulk-updates-selling-plan-tab": false,
  "variant-price-change-recording": false,
  "airbyte-product-initial-sync": false,
  "analytics-multi-dashboard": false,
  "display-home-page": false,
  "show-failed-payment-banner": true,
  "vendor-support-chat": true,
  "new-customer-table": false,
  "bill-list-improvement": false,
  "subscription-list-improvement": false,
  "vendor-portal-getting-started-page": false,
  "onboarding-v2": false,
  "klaviyo-integration-without-subscriber-external-id": false,
  "subscription-cancel-workflow": false,
  "saved-by-integration": false,
  "loyalty-improvement": false,
  "omni-analytics-include-user-attributes": false,
  "postscript-v-2": false,
  "loyalty-redemption-history": false,
  "selling-plan-next-order-date-calculation": false,
  "skip-shopify-cancel-for-perf-test": false,
  "retention-sub-pages": false,
  "next-order-card-actions": false,
  "manage-subscription-card-action-buttons": false,
  "loyalty-incentive-decision-flow": false,
  "vendor-portal-intercom": false,
  "send-merchant-price-change-email": false,
  "bundle-out-of-stock-auto-pause": false,
};

export type CamelCaseSmartrrFlags = KeysToCamelCase<typeof LaunchDarklyFlags>;
export const useSmartrrFlags = useFlags<CamelCaseSmartrrFlags>;

// clientSideID needs to be evaluated during runtime - use `ldGetClientSideId()`
export const LaunchDarklyOptions: Omit<AsyncProviderConfig, "clientSideID"> = {
  options: {
    streaming: true,
    bootstrap: "localStorage",
  },
  flags: LaunchDarklyFlags,
  reactOptions: {
    useCamelCaseFlagKeys: true,
    sendEventsOnFlagRead: true,
  },
};
